import {object, string,} from 'yup'
import * as Yup from 'yup';

export const resetPasswordSchema = object({
    password: string()
        .required('Required')
        .min(6, 'At least 6 characters'),

    confirmPassword: string()
        .required('Required')
        .min(6, 'At least 6 characters')
        .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});
